import { render, staticRenderFns } from "./GroupStep.vue?vue&type=template&id=6ff3509c&scoped=true&"
import script from "./GroupStep.vue?vue&type=script&lang=js&"
export * from "./GroupStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff3509c",
  null
  
)

export default component.exports